import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const WhySkilllaneCpdSectionStyle = withTheme(styled.div`
  margin: 10px 0px;
  padding: 10px 0px;
  background-color: #f5f5f5;
  text-align: center;
  .container {
    max-width: 1182px;
    margin: 40px auto;
    padding: 0px 20px;
  }
  .icon-group {
    display: flex;
    justify-content: center;
    align-items: top;
  }

  .icon1,
  .icon2,
  .icon3,
  .icon4,
  .icon5 {
    flex: 24%;
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .icon-group {
      flex-wrap: wrap;
    }
    .icon1,
    .icon2,
    .icon3 {
      flex: 24%;
    }
    .icon4,
    .icon5 {
      flex: 40%;
    }
  }

  ${(props: any) => props.theme.breakpoints.down('md')} {
    .container {
      padding: 0px 16px;
    }
    .topic {
      font-size: 24px;
      line-height: 24px;
    }
    .sub-topic {
      font-size: 18px;
      line-height: 22px;
    }
    .icon-group {
      padding-top: 20px;
    }
    .icon1,
    .icon2,
    .icon3,
    .icon4,
    .icon5 {
      flex: 100%;
    }
  }
`);

export default WhySkilllaneCpdSectionStyle;
